import React, { Fragment, useEffect, useState } from 'react';
import Dashboard from './defaultCliente';
import DashboardCliente from './defaultCliente';
import DefaultClienteCall from './defaultClienteCall';
import FolderStructure from './FolderStructure';
import { 
  Container, Row, Col, Card, CardHeader, CardBody, 
  Button, Badge, Spinner, Modal, ModalHeader, ModalBody
} from "reactstrap"
const Index = () => {
    let a = localStorage.getItem("admin")
    const [Administrator, setAdministrator] = React.useState(a);

    return (
        <div className="content">
        
                       
        
        
                        <div className="container-fluid">
                            <br />
                            <div className="card">
                                
                                <div className="card-body">
                                    
                                    <Dashboard />
                                </div>
                                
                            </div>
                        </div>
                    </div>
    );

}

export default Index;